module.exports = __webpack_public_path__ + "img/enterprise_banner1.50fedaca.png";